import { styled } from '@mui/material';

// Generate the title by search term and total count of results.
// The search term and its quotation marks should be emphasized.
// The quotation marks must be included in the translation (e.g. ..."{searchTerm}"...).
export const SearchResultPageHeadline = ({
  searchTerm,
  titleWithTotalCount,
}: {
  searchTerm: string;
  titleWithTotalCount: string;
}) => {
  const placeholder = '{searchTerm}';
  const searchTermInTitleIndex = titleWithTotalCount.indexOf(placeholder);
  const indexBeforeQuote = searchTermInTitleIndex - 1; // "-1" to get the index just before the beginning first quotation mark
  const indexAfterQuote = searchTermInTitleIndex + placeholder.length + 1; // "+1" to get the index just after the closing quotation mark

  const amountString = titleWithTotalCount
    .slice(indexBeforeQuote, indexAfterQuote)
    .replace(placeholder, searchTerm);

  return (
    <Headline>
      {titleWithTotalCount.slice(0, indexBeforeQuote)}
      <SearchTermSpan>{amountString}</SearchTermSpan>
      {titleWithTotalCount.slice(indexAfterQuote)}
    </Headline>
  );
};

const SearchTermSpan = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));

const Headline = styled('h1')(({ theme }) => ({
  ...theme.typography.h2,
  fontWeight: 'unset',
  marginBottom: '10px',
  marginTop: 0,

  [theme.breakpoints.up('sm')]: {
    marginBottom: '25px',
  },

  [theme.breakpoints.up('md')]: {
    marginBottom: '30px',
  },
}));
